export default "__VITE_ASSET__40f0$zU0__"